import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { CLOSE_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const CloseRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={CLOSE_ROUNDED_GLYPH} />;
